// 통합 유료서비스 이용약관
import { makeEmptyScreenNavigate } from '../../../shared/app/navigate';
import { navigateTo } from '../../../shared/app/util';

export const onIntegratedPaidServiceTermsTextClick = () => {
  navigateTo(`/${ET.lang}/@/terms`, makeEmptyScreenNavigate, { blank: true });
};
